import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { GrowthSkillMap } from 'components/pages/Growth/parts/GrowthSkillMap';

import { GrowthSectionLayout } from './GrowthSectionLayout';

/** /growth/skills — карта навыков своим адресом вместо `?tab=skills`. */
export const GrowthSkills = memo(() => {
  const { t } = useTranslation();

  return (
    <GrowthSectionLayout title={t('growth.map.title')} lead={t('growth.map.pageLead')}>
      <GrowthSkillMap />
    </GrowthSectionLayout>
  );
});
